import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';

import './assets/style/init.scss';
import mixin from './minxins/common.js'; // 过滤器
import ElementUI from 'zz-element-ui';
import DictSelect from './components/dict-select';
import Scrolls from './components/scrollsBar';
// import Table from './components/table';
// import TableColumn from './components/el-table-column';
import Popconfirm from './components/popconfirm';
import Dialog from './components/el-dialog';
import Message from './components/message/index';
import MessageBox from './components/message-box';
import Popover from './components/el-popover';
import Tooltip from './components/el-tooltip';
import Drawer from './components/el-drawer';
import Select from './components/el-select';
import Dropdown from './components/el-dropdown';
import DatePicker from './components/el-date-picker';
import Notification from './components/notification';
import Pagination from './components/el-pagination';
import ColorPicker from './components/el-color-picker';
import Image from './components/el-image';
import Cascader from './components/el-cascader';
import CascaderPanel from './components/el-cascader-panel';
import TooltipLine from './components/common/tooltip-line.vue';
import Empty from './components/common/empty.vue';
import footerFix from './components/common/footer-fixed/index.vue';
import { personalPage } from '@/utils/dict';
import Cookies from 'js-cookie';
import { menuMap } from '@/lib/menuFormat';
import {
  getSession,
  _local,
  clearStorageExcept
} from '@/utils/storage';

import { clearAllCookie, getQueryParams, redictToLogin, listToTree } from '@/utils/index';
import Locale from '@/components/utils/locale';
import {
  dataCheck,
  copy,
  deepClone,
  objectItemChangeNumber,
  formatThousandMark,
} from '@/utils';
import VueClipboard from 'vue-clipboard2';
import Treeselect from '@riophae/vue-treeselect';
import VueI18n from 'vue-i18n';
import globalDirective from './lib/directive/index';
import {
  loadTableDirect,
  menuDragDirect,
  saasAuth,
  saasBuried,
} from './directive/index';
import enLocal from './components/utils/locale/lang/en';
import zhLocal from './components/utils/locale/lang/zh-CN';
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
// import { defaultLocale, en } from './config/language'
import { en } from './config/language/en';
import { defaultLocale } from './config/language/zh-CN';
import { changeLanguage } from './config/index.js';
import { changePickerLanguage } from './utils/datepickerConfig';
import { getLanguage, getLanguageCDN, updateLanguageCDN } from '@/server/common';
import { getMerchantShopList } from '@/server/business';
import {
  getAuthorityMenu,
} from '@/server/common';
import { getUserInfo, validEmail } from '@/server/personal/contract';

const query = getQueryParams();
const systemId = 3;
const pathName = window.location.pathname;
const host = window.location.hostname
const cache = 7;
const cacheTime = 7 * 3600000 * 24;
const preAccountIgnores = ['/pearlgo-login', '/zhizh-login', '/gule-login', '/open-contract']
const version = 'v1.12'
const lang = Cookies.get('language') || 'zh-CN';
const windowSelf = window == window.top

window.$t = () => { }
window.$locale = {}
window.eventBus = {}
/**
 * @description: 如果是带token过来的重新设置cookie
 * @param {*} query
 * @param {*} host
 * @return {*}
 * @name: 
 */
function checkCacheLogin(query, host) {
  // TODO 黑操作，清理所有缓存
  if (query.clearCache) {
    clearStorageExcept([], true)
  }
  if (query.BITOSHOPLINK) {
    _local.set('BITOSHOPLINK', query.BITOSHOPLINK)
  }
  if (query.token) {
    // 清理当前域名的cookie
    clearAllCookie();
    clearStorageExcept()
    sessionStorage.clear();
    if (query && query.userId) {
      _local.set('userId', query.userId);
    } else {
      // 如果没有店铺系统那边没有携带userId 过来，先清理掉cookie 再重新set
      document.cookie = `userId=0;domain=${host};expires=${new Date(0).toUTCString()}`;
      // _local.set('userId', _local.get('userId'));
    }

    // 设置系统cookie
    Cookies.set('saasToken', query.token, { domain: host, expires: cache });
    _local.set('saasToken', query.token)
    // 设置domain 如果在login端检查到为system=3并且cookie中有domain缓存会直接跳转到当前系统
    Cookies.set('domain', host, { domain: process.env.VUE_APP_DOMAIN, expires: cache });
    if (query && query.backUrl) {
      _local.set('backUrl', query.backUrl);
    }
  }
  // 检查缓存版本
  if (_local.get('version') && _local.get('version') != version) {
    clearAllCookie();
    clearStorageExcept()
    _local.set('version', version)
    setTimeout(() => {
      window.location.href = query.token ? window.location.href : process.env.VUE_APP_LOGINURL
    }, 100)
  } else {
    if (!_local.get('version')) {
      _local.set('version', version)
    }
  }
  if (_local.get('language-data') && lang === getSession('language')) {
    window.$locale = _local.get('language-data');
  } else if (lang === 'en') {
    window.$locale = en;
  } else {
    window.$locale = defaultLocale;
  }

}


// 预账号入口跳过systemId设置：erp 等login入口在BI 跳到BI时systemId设置会导致登录后再次回到BI而不会跳到对应系统
if (!preAccountIgnores.includes(pathName) && windowSelf) {
  Cookies.set('systemId', systemId, { domain: process.env.VUE_APP_DOMAIN, expires: cache });
}

const isDemo = window.location.search.includes('isDemo');

// 根据缓存设置preAccount
if (Cookies.get('preAccount') && Cookies.get('preAccount') !== 'undefined') {
  Vue.prototype.$preAccount = Cookies.get('preAccount')
}



// if (merchantId) {
//   sessionStorage.clear();
//   store.commit('setMenus', []);
//   store.commit('user.setMerchantId', merchantId);
// }

function autoValidEmail(code, data) {
  validEmail({
    userId: data.data.userId,
    markId: query.markId,
    validCode: code,
    email: data.data.email,
  });
}
checkCacheLogin(query, host)
const doInitApp = async (query, lang, resolve) => {
  // 消息中心跳转切换到当前商家
  const merchantId = query && !query.merchantIdInPayPal && query.merchantId;
  if (query.token || (!_local.get('saasToken') && Cookies.get('token'))) {
    checkCacheLogin(query, host)
    _local.set('saasToken', query.token || Cookies.get('token'))
    const { data } = await getUserInfo();
    if (data.code === 0) {

      // 获取报表提示弹窗设置 
      if (data.data.config) {
        _local.set('report_local', JSON.parse(data.data.config))
      } else {
        _local.set('report_local', { orderAnalysis: 1, biScreen: 1, monthReport: 1, dayReport: 1 })
      }
      _local.set('userName', data.data.loginName);
      _local.set('userId', data.data.id);
      _local.set('userInfo', data.data);
      store.commit('user.setValue', { key: 'userId', value: data.data.id });
      Cookies.set('authorizationCode', data.data.authorizationCode || '', {
        domain: host,
        expires: cache,
      });
      _local.set('available_system_ids', (data.data.systemStatusList || []).filter(el => el.enabled).map(el => el.systemId).join(','),
        { domain: host, expires: cache });
      Cookies.set(
        'available_system_ids',
        (data.data.systemStatusList || []).filter(el => el.enabled).map(el => el.systemId).join(','),
        { domain: host, expires: cache }
      );
      store.commit('user.setUserName');
      if (data.data.authorizationCode) {
        // 预账号 merchantId  // 100：创乐， 101：MW 102：RL 104：谷乐 
        const tempMerchantId = data.data.authorizationCode.split('#')[0]
        if (query && query.preAccount && query.preAccount !== 'undefined') {
          Cookies.set('preAccount', query.preAccount, { domain: host, expires: cache });
          // preAccount逻辑 ： 判断是否为至真账号或是为其他账号 2：创乐， 1：至真

        } else if (tempMerchantId == 100) {
          Cookies.set('preAccount', 2, { domain: host, expires: cache });
          _local.set('preAccount', 2)
        } else if (tempMerchantId == 104) {
          Cookies.set('preAccount', 3, { domain: host, expires: cache })
        } else {
          Cookies.set('preAccount', 1, { domain: host, expires: cache });
          _local.set('preAccount', 1)
        }
        Vue.prototype.$preAccount = Cookies.get('preAccount')
      }
      // 静默认证邮箱
      if (query.code) {
        autoValidEmail(query.code, data);
      }
    } else {
      Message.error('token已失效，请重新登录');
      setTimeout(() => {
        redictToLogin()
      }, 1000);
    }
    console.log(query, 'query');
    if (!_local.get('merchantId') && !merchantId) {
      await store.dispatch('getMerchant');
    } else {
      store.commit('user.setMerchantId', merchantId || _local.get('merchantId'))
      await store.dispatch('getMerchant');
    }
    if (!preAccountIgnores.includes(pathName) && !isDemo) {
      await store.dispatch('getUserAuth')
      await store.dispatch('getCombo')
      if (_local.get('merchantId')) {
        store.dispatch('autoBindQue')
      }
    }
  } else {
    if (_local.get('preAccount')) {
      Cookies.set('preAccount', _local.get('preAccount')
      )
    }
    if (_local.get('available_system_ids')) {
      Cookies.set('available_system_ids', _local.get('available_system_ids')
      )
    }
    if (query.BITOSHOPLINK) {
      _local.set('BITOSHOPLINK', query.BITOSHOPLINK)
    }
    if (!preAccountIgnores.includes(pathName) && !isDemo) {
      await store.dispatch('getUserAuth')
      await store.dispatch('getCombo')
      if (!_local.get('merchantId') && !merchantId) {
        await store.dispatch('getMerchant');
      } else {
        store.commit('user.setMerchantId', merchantId || _local.get('merchantId'))
        await store.dispatch('getMerchant');
      }
      if (_local.get('merchantId')) {
        store.dispatch('autoBindQue')
      }
    }
  }
  resolve && resolve(lang)
}
const appBuild = () => new Promise((resolve, reject) => {
  doInitApp(query, lang, resolve);
}).then(lang => {
  const localeElement = lang === 'en' ? enLocal : zhLocal;
  Locale.use(localeElement);
  Vue.use(VueI18n);
  Vue.component(TooltipLine.name, TooltipLine);
  Vue.component(Empty.name, Empty);
  Vue.component('tree-select', Treeselect);
  Vue.component(footerFix.name, footerFix);
  Vue.use(saasAuth);
  Vue.use(saasBuried);
  Vue.prototype.$hasInitZIndex = false;
  Vue.use(VueClipboard);
  // 注册组件
  const commonComponents = require.context(
    './components/common/',
    true,
    /index.js$/
  );
  commonComponents.keys().forEach(i => {
    const com = commonComponents(i).default;
    Vue.component(com.name, com);
  });
  // 注入自定义指令
  Object.values(globalDirective).forEach(value => Vue.use(value));

  ElementUI.Card.props.shadow.default = 'never';
  Vue.prototype.$code = 0;
  Vue.component(DictSelect.name, DictSelect);
  Vue.prototype.$addEventOnResize = function addEventOnResize(fn) {
    var originFn = window.onresize;
    window.onresize = function () {
      originFn && originFn();
      fn();
    };
  };
  Vue.prototype.$windowSelf = windowSelf
  Vue.prototype.$systemId = systemId;
  Vue.prototype.$formatThousandMark = formatThousandMark;
  Vue.prototype.$ObjectItemChangeNumber = objectItemChangeNumber;
  Vue.prototype.$dataCheck = dataCheck;
  Vue.prototype.$copy = copy;
  Vue.prototype.$deepClone = deepClone;
  Vue.config.productionTip = false;
  Vue.prototype.$demo = _local.get('userId') === '5144'
  // 如果是demo账号，不显示引导
  if (Vue.prototype.$demo) {
    _local.set('hasClose', true);
  }
  Vue.mixin(mixin);

  // 默认获取浏览器语言
  // if (!Cookies.get('language')) {
  //   Cookies.set('language', (window.navigator.language.indexOf('en') === 0 ? 'en' : 'zh-CN'), {
  //     domain: host,
  //     expires: 7
  //   })
  // }


  const messages = {
    [lang]: {
      ...localeElement,
    },
  };
  // element语言包
  const i18n = new VueI18n({
    locale: lang, // set locale
    messages, // set locale messages
    silentTranslationWarn: true,
  });
  // 语言替换
  Vue.prototype.$t = function (key, data) {
    const locale = appInt.langData;
    if (data && data instanceof Object) {
      let str = locale && locale[key];
      if (!str) return key;
      const arr = str.match(new RegExp('\{[^\{|\}]*\}?', 'g'));
      Object.keys(data).forEach(item => {
        data[item.toUpperCase()] = data[item];
      });
      arr.forEach(item => {
        const upperCase = item
          .toUpperCase()
          .replace(new RegExp('\{|\}', 'g'), '')
          .trim();
        str = str.replace(item, data[upperCase]);
      });
      return str;
    } else if (data && !(locale && locale[key])) {
      return data;
    } else {
      if (locale && locale[key]) {
        return locale && locale[key];
      } else {
        return key ? key.split('::').pop() : key;
      }
    }
  };

  window.$t = Vue.prototype.$t;

  Vue.use(ElementUI, {
    i18n: (key, value) => i18n.t(key, value),
  });
  // Vue.use(Select);
  // Vue.use(Dropdown);
  // Vue.use(DatePicker);
  // Vue.use(Cascader);
  // Vue.use(CascaderPanel);
  // Vue.use(Tooltip);
  // Vue.use(Drawer);
  // Vue.use(Popconfirm);
  // Vue.use(Popover);
  Vue.use(Scrolls);
  // Vue.use(ColorPicker);
  // Vue.use(TableColumn);
  // Vue.use(Table);
  // Vue.use(Dialog);
  // Vue.use(Pagination);
  Vue.use(Image);
  Vue.prototype.$msgbox = MessageBox;
  Vue.prototype.$alert = MessageBox.alert;
  Vue.prototype.$confirm = MessageBox.confirm;
  Vue.prototype.$prompt = MessageBox.prompt;
  Vue.prototype.$notify = Notification;

  Vue.directive('loadTable', loadTableDirect);
  Vue.directive('menuDrag', menuDragDirect);

  const appInt = new Vue({
    data() {
      return {
        langData: window.$locale
      }
    },
    async mounted() {
      if (!preAccountIgnores.includes(pathName)) {
        getLanguageType(lang, (data) => {
          this.langData = data
          changeLanguage();
          changePickerLanguage();
        });
      }
    },
    router,
    store,
    i18n,
    render: h => h(App),
  }).$mount('#app');
  window.eventBus = appInt
});

async function getLanguageType(lang, callback) {
  // 如果只判断是否有缓存，在切换语言的时候，本地key值不会更新
  if (_local.get('language-data') && lang === getSession('language')) {
    window.$locale = _local.get('language-data');
  } else if (lang === 'en') {
    window.$locale = en;
  } else {
    window.$locale = defaultLocale;
  }
  // v2版本，读cdn数据内容，数据压缩，同时缓存
  getLanguageCDN({ systemId, language: lang }).then(res => {
    store.commit('setLanguage', lang);
    if (res.data.code === 0) {
      const fileUrl = res.data.data.fileUrl;
      if (_local.get('language-url') != res.data.data.fileUrl) {
        _local.remove('language-url');
        _local.remove('language-data');
        updateLanguageCDN(fileUrl).then(async res => {
          if (res.code === 0) {
            _local.set('language-url', fileUrl, cacheTime);
            const newLang = deepClone(window.$locale) || {};
            await res.response.data.forEach(el => {
              newLang[el.name] = el.message;
            });
            window.$locale = {
              ...(window.$locale || {}),
              ...newLang,
            };
            callback(window.$locale);
            _local.set('language-data', newLang, cacheTime);
          }
        });
      } else {
        callback(window.$locale);
      }
    } else {
      getLanguage({ systemId, language: lang }).then(res => {
        if (res.data.code === 0) {
          res.data.data.forEach(el => {
            window.$locale[el.name] = el.message;
          });
          callback(window.$locale);
        }
      });
    }
  });
}
if (!query.LOGINCACHE) {
  appBuild()
}
